export default __webpack_public_path__ + "static/media/128.2ba422c4.jpg";